import React, { useState } from 'react'
import { MDBPagination, MDBPageItem, MDBPageNav, MDBCol, MDBRow } from "mdbreact";

const ITEMS_POR_PAGINA = 4;

const MostrarComponentes = ({ campos, campoSeleccionado }) => {

    const [camposActuales, setCamposActuales] = useState(campos)
    const [items, setItems] = useState([...campos].splice(0, ITEMS_POR_PAGINA))

    const [paginaActual, setPaginaActual] = useState(0)

    const handleSiguiente = () => {
        const totalElementos = camposActuales.length;
        const paginaSiguiente = paginaActual + 1;
        const primerIndex = paginaSiguiente * ITEMS_POR_PAGINA;

        if (primerIndex >= totalElementos) return;

        setItems([...camposActuales].splice(primerIndex, ITEMS_POR_PAGINA))
        setPaginaActual(paginaSiguiente)
    }

    const handleRegresar = () => {
        const paginaAnterior = paginaActual - 1;

        if (paginaAnterior < 0) return;
        const primerIndex = paginaAnterior * ITEMS_POR_PAGINA;

        setItems([...camposActuales].splice(primerIndex, ITEMS_POR_PAGINA))
        setPaginaActual(paginaAnterior)

    }

    return (
        <nav aria-label='Page navigation example'>

            <div className='campos-input-container'>
                {items && items.map((campo) => (
                    <div key={campo.title}>
                        <div className='campo-input-referente' onClick={() => campoSeleccionado({ campo })}>
                            <span>{campo.title}</span>
                        </div>
                    </div>
                ))}
            </div>

            <MDBPagination className="mb-0">
                <MDBPageItem>
                    <MDBPageNav aria-label="Previous" onClick={handleRegresar}>
                        <span aria-hidden="true">&laquo;</span>
                    </MDBPageNav>
                </MDBPageItem>

                <MDBPageItem>
                    <MDBPageNav aria-label="Previous" onClick={handleSiguiente}>
                        <span aria-hidden="true">&raquo;</span>
                    </MDBPageNav>
                </MDBPageItem>
            </MDBPagination>


        </nav>
    )
}

export default MostrarComponentes